// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative import
import actions from '../../actions/actions';
import landingPageActions from '../../actions/landingPage';
import LandingPage from './LandingPage';
import {localizeUrl} from '@homeaway/localization-utils';
import {DEEP_LINK_PARAM_TYPE} from '../../utils/localStorageDataHandler';
import {redirectToQCWebform} from '../utils/webFormUtil';
import { isUsSite } from '../../utils/validate';

function mapStateToProps(state) {
    return {
        state,
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),
        publicUuid: get(state, 'app.publicUuid', '-1'),
        siteName: state.system.siteName,
        preferredLocale: state.system.preferredLocale,
        environment: state.system.environment,
        nodeEnvironment: state.system.nodeEnvironment,
        pmscParams: get(state, 'app.pmscParams', {}),
        cardQuestionId: get(state, 'landingPage.cardQuestionId', ''),
        accountStatus: get(state, 'landingPage.accountStatus', ''),
        leadsFormSite: get(state, 'landingPage.leadsFormSite', ''),
        redirectPath: state.app.redirectPath,
        supportedBrands: state.app.supportedBrands,
        language: state.landingPage.language,
        dyff: get(state,'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        landingPageActions: bindActionCreators(landingPageActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class LandingPageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleGetStartedClick = this.handleGetStartedClick.bind(this);
        this.handleYesClick = this.handleYesClick.bind(this);
        this.handleNoClick = this.handleNoClick.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.leftArrowOnClick = this.leftArrowOnClick.bind(this);
        this.handleStartClick = this.handleStartClick.bind(this);
        this.handleLanguageSelection = this.handleLanguageSelection.bind(this);
        this.getSelectedLocale = this.getSelectedLocale.bind(this);
    }

    componentWillMount() {
        this.props.landingPageActions.setCardDetails('card_1');
        this.props.landingPageActions.getLeadsFormSite(this.props.siteName);
        this.getSelectedLocale();
    }

    componentDidMount() {
        if (!(this.props.redirectPath)) {
            this.props.actions.enableLoadOverLay(false);
        }
        const {advertiserAssignedId, currency, systemId, systemName} = this.props.pmscParams;

        if (advertiserAssignedId || systemId || currency) {
            this.props.actions.saveDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams, {advertiserAssignedId, systemName, systemId, currency});
        }

        if (this.props.userType === 'TRAVELER') {
            this.props.landingPageActions.setAccountStatus('No');
            this.props.landingPageActions.setCardDetails('card_2');
        }
    }

    triggerEdapPageViewAction() {
        this.props.actions.triggerEdapPageView(this.props.publicUuid, 'Landing Page');
    }

    triggerEdapEventonClick(eventCategory) {
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: eventCategory
        }, {});
    }

    handleGetStartedClick() {
        this.triggerEdapEventonClick('Get Started');
        const questionCard = document.getElementsByClassName('qns-card-outer')[0];
        questionCard.scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    redirectToLeadsForm(type) {
        window.location = this.props.leadsFormSite;
        this.triggerEdapEventonClick(type);
    }

    redirectToPPMLogin() {
        window.location = localizeUrl('/p/onboard/login', window.__SITE_CONTEXT__);
    }

    handleYesClick() {
        const hasAccount = 'Has Account: Yes';
        const hasSoftware = 'Has software: Yes';
        const {cardQuestionId, accountStatus, preferredLocale, environment, nodeEnvironment, siteName} = this.props;

        if (cardQuestionId === 'card_1') {
            this.triggerEdapEventonClick(hasAccount);
            this.props.landingPageActions.setAccountStatus('Yes');
            this.props.landingPageActions.setCardDetails('card_2');
        } else if (cardQuestionId === 'card_2') {
            this.triggerEdapEventonClick(hasSoftware);
            if (isUsSite(siteName)) {
                if (accountStatus === 'No' && preferredLocale !== 'ja_JP') {
                    this.props.landingPageActions.setCardDetails('card_3');
                } else if (accountStatus === 'No' && preferredLocale === 'ja_JP') {
                    redirectToQCWebform('', preferredLocale, environment, nodeEnvironment);
                } else if (accountStatus === 'Yes' && preferredLocale === 'ja_JP') {
                    redirectToQCWebform('/login', preferredLocale, environment, nodeEnvironment);
                } else {
                    this.redirectToPPMLogin();
                }
            } else if ((preferredLocale === 'ja_JP' || siteName === 'homeaway_jp') && accountStatus === 'Yes') {
                    redirectToQCWebform('/login', preferredLocale, environment, nodeEnvironment);
                } else if (this.props.accountStatus === 'Yes') {
                    this.redirectToPPMLogin();
                } else if ((preferredLocale === 'ja_JP' || siteName === 'homeaway_jp') && accountStatus === 'No') {
                redirectToQCWebform('', preferredLocale, environment, nodeEnvironment);
                } else if (this.props.dyff?.HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH) {
                    this.props.actions.changeAppState('BANKING_LOCATION');
                } else {
                    this.props.actions.changeAppState('BASIC_INFORMATION');
                }
        }

    }

    handleStartClick() {

        const hasSoftware = 'Has software: Yes';
        const {accountStatus, preferredLocale, environment, nodeEnvironment, siteName, language} = this.props;

        this.triggerEdapEventonClick(hasSoftware);

        if ((preferredLocale === 'ja_JP' || siteName === 'homeaway_jp' || language === 'ja_JP') && accountStatus === 'Yes') {
            redirectToQCWebform('/login', preferredLocale, environment, nodeEnvironment);
        } else if (this.props.accountStatus === 'Yes') {
            this.redirectToPPMLogin();
        } else if ((preferredLocale === 'ja_JP' || siteName === 'homeaway_jp' || language === 'ja_JP') && accountStatus === 'No') {
            redirectToQCWebform('', preferredLocale, environment, nodeEnvironment);
        } else if (this.props.dyff?.HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH) {
            this.props.actions.changeAppState('BANKING_LOCATION');
        } else {
            this.props.actions.changeAppState('BASIC_INFORMATION');
        }
    }

    handleNoClick() {
        const hasAccount = 'Has Account: No';
        const hasSoftware = 'Has software: No';
        const {cardQuestionId, accountStatus, preferredLocale, environment, nodeEnvironment} = this.props;

        if (cardQuestionId === 'card_1') {
            this.triggerEdapEventonClick(hasAccount);
            this.props.landingPageActions.setAccountStatus('No');
            this.props.landingPageActions.setCardDetails('card_2');
        } else {
            this.triggerEdapEventonClick(hasSoftware);
            if (accountStatus === 'Yes') {
                redirectToQCWebform('/login', preferredLocale, environment, nodeEnvironment);
            } else {
                redirectToQCWebform('', preferredLocale, environment, nodeEnvironment);
            }
        }
    }

    leftArrowOnClick() {
        if (this.props.cardQuestionId === 'card_3') {
            this.props.landingPageActions.setCardDetails('card_2');
        } else {
            this.props.landingPageActions.setCardDetails('card_1');
        }

    }

    handleLanguageSelection = (event) => {
        const value = event.target.value;
        this.props.landingPageActions.setLanguage(value);
    }

    getSelectedLocale = () => {
        const {supportedBrands, preferredLocale} = this.props;
        const selectedLocale = supportedBrands.filter((brandSelection) => {
            return brandSelection.locale === preferredLocale;
        })[0];
        if (selectedLocale) {
            this.props.landingPageActions.setLanguage(selectedLocale.locale);
        } else {
            this.props.landingPageActions.setLanguage('en_US');
        }


        return selectedLocale;
    }

    render() {
        const {translations} = this.props;

        return (
            <LandingPage
                translations={translations}
                siteName={this.props.siteName}
                handleGetStartedClick = {this.handleGetStartedClick}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleYesClick={this.handleYesClick}
                handleNoClick={this.handleNoClick}
                cardQuestionId={this.props.cardQuestionId}
                leftArrowOnClick={this.leftArrowOnClick}
                userType={this.props.userType}
                handleStartClick={this.handleStartClick}
                supportedBrands={this.props.supportedBrands}
                publicUuid={this.props.publicUuid}
                preferredLocale={this.props.preferredLocale}
                savePreferredLocale={this.props.actions.savePreferredLocale}
                handleLanguageSelection={this.handleLanguageSelection}
                getSelectedLocale={this.getSelectedLocale}
                language={this.props.language}

            />
        );
    }
}

LandingPageContainer.propTypes = {
    handleGetStartedClick: PropTypes.func,
    siteName: PropTypes.string,
    publicUuid: PropTypes.string,
    userType: PropTypes.string,
    language: PropTypes.string,
    translations: PropTypes.any // eslint-disable-line react/forbid-prop-types
};
